/* unplugin-vue-components disabled */import { render } from "./support.vue?vue&type=template&id=f9dc54a4&scoped=true"
const script = {}

import "./support.vue?vue&type=style&index=0&id=f9dc54a4&scoped=true&lang=css"

import exportComponent from "E:\\work\\wwwroot\\new-landing-page-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9dc54a4"]])

export default __exports__